import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { Box, InputAdornment, MenuItem, TextField } from '@mui/material';
import { useState } from 'react';
import { isEUIValid } from '@iotv/datamodel';
import AppDao from '../../data/AppDao';
const prefix = '70B3D516B000';
export const DATE_CHOICES = [
    { name: 'All', id: '0' },
    { name: '1 Day', id: '1' },
    { name: '3 Days', id: '3' },
    { name: '1 Week', id: '7' },
    { name: '2 Weeks', id: '14' },
    { name: '1 Month', id: '30' },
    { name: '6 Months', id: '183' },
    { name: '1 Year', id: '365' },
];
export const convertListToSelectorMinimum = (values) => {
    return values.map((val, i) => {
        return { id: i + '', name: val };
    });
};
export const getDevice = async (devEUI) => {
    let res = undefined;
    const device = {
        ...getZombieInstanceFromPrimaryKey(`Device:${devEUI}`),
        type: 'Device',
    };
    const deviceObject = await AppDao.getOne(device);
    res = deviceObject.data !== null ? deviceObject.data : undefined;
    return res;
};
export const DeviceFields = (props) => {
    const { source, setter, change } = props;
    const initSuffix = source.deviceEui?.substring(12);
    const [suffix, setSuffix] = useState(initSuffix || '');
    return (_jsx("div", { id: "deviceFields", children: _jsx(Box, { m: 2, children: _jsx(TextField, { onChange: (e) => {
                    const newEUI = e.target.value.toLocaleUpperCase();
                    setSuffix(newEUI);
                    setter({ ...source, deviceEui: prefix + newEUI });
                },
                value: suffix,
                autoComplete: 'off',
                error: !isEUIValid(source.deviceEui),
                label: 'DevEUI',
                variant: 'outlined',
                disabled: change,
                InputProps: {
                    startAdornment: _jsxs(InputAdornment, { position: "start", children: [" ", prefix, " "] }),
                    spellCheck: false,
                } }) }) }));
};
export const SelectorGeneric = (props) => {
    const { description, choices, choice, choose, disabled = false, all, none, issue, sort = false } = props;
    let initial = '';
    if (none) {
        initial = 'None';
    }
    else if (all) {
        initial = 'All';
    }
    const [display, setDisplay] = useState(initial);
    const changeSelected = (id) => {
        if (id === 'All' || id === 'None') {
            setDisplay(id);
            choose(undefined);
        }
        else {
            setDisplay('');
        }
        const found = choices?.find((sel) => sel.id === id);
        if (found) {
            choose(found);
        }
    };
    return (
    // <Box m={2}>
    // </Box>
    _jsx("div", { style: {
            paddingLeft: '18px',
            paddingRight: '18px',
            paddingTop: '9px',
            paddingBottom: '9px',
            minWidth: '200px',
        }, children: _jsxs(TextField, { select: true, label: choices ? `Select${choice ? 'ed' : ''} ${description}` : 'Loading', value: choice?.id || display || '', onChange: (e) => changeSelected(e.target.value), fullWidth: true, error: issue, size: "small", variant: "outlined", disabled: choices === undefined || disabled, SelectProps: {
                renderValue: () => _jsxs(_Fragment, { children: [" ", choice?.name || display] }),
                MenuProps: { style: { maxHeight: '40vh' } },
            }, children: [none && (_jsx(MenuItem, { value: 'None', children: _jsx("i", { children: 'None' }) }, 'None')), all && (_jsx(MenuItem, { value: 'All', children: _jsx("i", { children: 'All' }) }, 'All')), choices &&
                    (sort
                        ? choices.sort((a, b) => {
                            return a.name?.localeCompare(b.name, undefined, {
                                numeric: true,
                                sensitivity: 'base',
                            });
                        })
                        : choices).map((choice) => (_jsx(MenuItem, { value: choice.id, children: choice.name }, choice.id)))] }) }));
};
export default DeviceFields;
